// tslint:disable:jsx-no-lambda 
// tslint:disable:react-this-binding-issue
import * as React from 'react';
import { v4 } from 'uuid';
import styles from './choose-chart-type.scss';
import { Tooltip } from 'ui/common/tooltip/tooltip';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { LayoutType } from '../types-store';
import { Value } from 'app/types-shared';

export interface ChooseChartTypeTranslation {
  choose_chart_type_limit_message_singular: string;
  choose_chart_type_limit_message_plural: string;
}

interface ChooseChartTypeComponentProps {
  amountOfSelectionCriterias: number;
  selectedLayoutType: number;
  layoutTypes: LayoutType[];
  onSetLayoutType: (type: Value) => void;
  translations: ChooseChartTypeTranslation;
}

class ChooseChartTypeComponent extends React.Component<ChooseChartTypeComponentProps, {}> {
  private uid: string = v4();

  private tooltipMessage = (lt: LayoutType) => {
    const { translations } = this.props;
    const layoutType = lt.type.d;
    const amount = lt.maxSelectionCriteria;
    const text = lt.maxSelectionCriteria > 1
      ? translations.choose_chart_type_limit_message_plural
      : translations.choose_chart_type_limit_message_singular;
    return text.replace('<LAYOUT_TYPE>', layoutType).replace('<AMOUNT>', String(amount));
  }
  private setLayoutType = (lt: LayoutType) => {
    if (this.props.amountOfSelectionCriterias <= lt.maxSelectionCriteria) {
      this.props.onSetLayoutType(lt.type);
    }
  }
  private renderLayoutTypeBlock = (lt: LayoutType) => {
    const disabled = this.props.amountOfSelectionCriterias > lt.maxSelectionCriteria;
    const uniqueId = `chart-type-${lt.type.d.replace(/\s/g, '')}-${this.uid}`;

    const content = <div key={lt.type.v} title={lt.type.d} className={styles.chartOption}>
      <input
        type="radio"
        className="visuallyhidden"
        name={`select-chart-type-${this.uid}`}
        id={uniqueId}
        value={lt.type.v}
        onChange={() => this.setLayoutType(lt)}
        checked={this.props.selectedLayoutType === lt.type.v}
        disabled={disabled}
      />

      <label htmlFor={uniqueId}>
        <span className="visuallyhidden">{lt.type.d}</span>
        {lt.iconUrl ? <img src={toAbsoluteUrl(lt.iconUrl)} /> : !!lt.type && !!lt.type.d && lt.type.d}
      </label>
    </div>;

    return !!disabled
      ? <Tooltip key={lt.type.v} className="" title={this.tooltipMessage(lt)}>{content}</Tooltip>
      : content;
  }
  public render(): JSX.Element {

    const { layoutTypes } = this.props;

    if (!layoutTypes) {
      return null;
    }

    return (
      <div className={`btn-group ${styles.chartSelector}`}>
        {layoutTypes.map(lt => this.renderLayoutTypeBlock(lt))}
      </div>);
  }
}

export const ChooseChartType = ChooseChartTypeComponent;
